export enum EVarbind2Systems {
	UNKNOWN = 'UNKNOWN',
	TIMER_FTP = 'TIMER-FTP',
	DMZ_SYNC = 'DMZ-SYNC',
}
